import React from 'react';
import logo from './logo192.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Join Mellie
        </p>
        <a
          className="App-link"
          href="https://www.mellie.com/download"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download Mellie
        </a>
      </header>
    </div>
  );
}

export default App;
